// extracted by mini-css-extract-plugin
var _1 = "kREYW";
export { _1 as "base" }
